const l = (e) => Object.keys(e).filter((c) => e[c] !== !1).reduce((c, f) => ({ ...c, [f]: e[f] }), {});
export {
  l as attributes
};
//# sourceMappingURL=attributes.js.map
